<script setup>
  import { storeToRefs } from "pinia";
  import { Input } from "@/components/ui/input";
  import { Checkbox } from "@/components/ui/checkbox";
  import { LabeledField } from "@/components/episto-ui/labeled-field";
  import { useMAudienceStore } from "@stores/mAudience/mAudience";

  const audienceStore = useMAudienceStore();

  const { getMAudience } = storeToRefs(audienceStore);
  const { updateMAudienceChannel } = audienceStore;
</script>

<template>
  <LabeledField label="Name">
    <Input v-model="getMAudience.name" />
  </LabeledField>
  <LabeledField label="Label">
    <Input v-model="getMAudience.label" />
  </LabeledField>
  <LabeledField label="Channels">
    <template #default>
      <div class="flex gap-6">
        <label class="flex items-center gap-2">
          <Checkbox
            :model-value="getMAudience.channels?.facebook"
            @update:model-value="updateMAudienceChannel('facebook', $event)" />
          <span class="text-sm">Facebook</span>
        </label>
        <label class="flex items-center gap-2">
          <Checkbox
            :model-value="getMAudience.channels?.instagram"
            @update:model-value="updateMAudienceChannel('instagram', $event)" />
          <span class="text-sm">Instagram</span>
        </label>
      </div>
    </template>
  </LabeledField>
</template>
